import { convertLabelMapToConfig, convertLabelUomMapToConfig, mergeConfig } from '../../../Core/Helpers/configHelpers';

const getLabelConfig = (prefix: string) =>
  mergeConfig(
    convertLabelMapToConfig({
      //Oversize correction
      [`${prefix}.OversizeCorrectionData.NoOversizeMaterial`]: `No Oversize Material`,
      [`${prefix}.OversizeCorrectionData.OversizeVolume`]: `Oversize Volume`,
      [`${prefix}.OversizeCorrectionData.OversizeDensity`]: `Oversize Density`,
      [`${prefix}.OversizeCorrectionData.OversizeSieveApertureSize`]: `Oversize Sieve Aperture Size`,
      [`${prefix}.OversizeCorrectionData.OversizePropertytoCalculate`]: `Oversize Property to Calculate`,
      [`${prefix}.OversizeCorrectionData.TrayUsedFromMDD`]: `Tray from Maximum Dry Density test is used`,
      [`${prefix}.OversizeCorrectionData.OversizeMaterialWetMass`]: `Oversize Material Wet Mass`,
      [`${prefix}.OversizeCorrectionData.TotalSampleWetMass`]: `Total Sample Wet Mass`,
      [`${prefix}.OversizeCorrectionData.TareAndTotalSampleWetMass`]: `Tare and Sample Wet Mass`,
      [`${prefix}.OversizeCorrectionData.OversizeCorrectionConstantDryMass.DryingTray.ContainerMass`]: `Tare Mass`,

      //Oversize Correction - Constant Dry Mass (embeddeded MC dry mass grid)
      [`${prefix}.OversizeCorrectionData.OversizeCorrectionConstantDryMass.DryingTray.DryMassReadings.DryingTime`]:
        'Drying Time',
      [`${prefix}.OversizeCorrectionData.OversizeCorrectionConstantDryMass.DryingTray.ConstantDrySoilMass`]:
        'Oversize Material Dry Mass',
      [`${prefix}.OversizeCorrectionData.OversizeCorrectionConstantDryMass.DryingTray.WetSoilAndContainerMass`]: `Tare and Oversize Material Wet Mass`,

      //Field Results
      [`${prefix}.FieldResults.LabMoistureTaken`]: `Laboratory Moisture Content Taken`,
      [`${prefix}.FieldResults.FieldWetDensity`]: `Wet Density`,
      [`${prefix}.FieldResults.FieldMoistureContent`]: `Moisture Content`,
      [`${prefix}.FieldResults.StabiliserUsed`]: `Stabilised Material`,
      [`${prefix}.FieldResults.TimesBetweenAdditionOfStabiliserAndCompaction`]: 'Addition of Stabiliser to Compaction',
      [`${prefix}.FieldResults.TimeBetweenAdditionOfStabiliserAndCompaction`]: 'Addition of Stabiliser to Compaction',
      [`${prefix}.FieldResults.CompactiveEffort`]: `Compactive Effort`,
      [`${prefix}.FieldResults.TareMass`]: `Tare Mass`,
      [`${prefix}.FieldResults.TotalWetSampleMass`]: `Total Sample Wet Mass`,
      [`${prefix}.FieldResults.OversizeSieveSize`]: `Oversize Sieve Aperture Size`,
      [`${prefix}.FieldResults.OversizeMaterialWetMass`]: `Oversize Material Wet Mass`,
      [`${prefix}.FieldResults.MaximumDryDensity`]: `Maximum Dry Density`,
      [`${prefix}.FieldResults.OptimumMoistureContent`]: `Optimum Moisture Content`,
      [`${prefix}.FieldResults.AssignedDate`]: 'Date Assigned',
      [`${prefix}.FieldResults.LabMoistureContent`]: `Moisture Content`,
      [`${prefix}.FieldResults.AssociatedCompactionData.ImportedTest`]: `Laboratory Density Sample ID`,
      [`${prefix}.FieldResults.AssociatedCompactionData.ExternalTest.Results.StabiliserUsed`]: `Stabilised Material`,
      [`${prefix}.FieldResults.AssociatedCompactionData.ExternalTest.Results.TimeBetweenAdditionOfStabiliserAndCompaction`]:
        'Addition of Stabiliser to Compaction',
      [`${prefix}.FieldResults.AssociatedCompactionData.ExternalTest.Results.CompactiveEffort`]: `Compactive Effort`,
      [`${prefix}.FieldResults.AssociatedCompactionData.ExternalTest.Results.TareMass`]: `Tare Mass`,
      [`${prefix}.FieldResults.AssociatedCompactionData.ExternalTest.Results.TotalWetSampleMass`]: `Total Sample Wet Mass`,
      [`${prefix}.FieldResults.AssociatedCompactionData.ExternalTest.Results.OversizeSieveSize`]: `Oversize Sieve Aperture Size`,
      [`${prefix}.FieldResults.AssociatedCompactionData.ExternalTest.Results.OversizeMaterialWetMass`]: `Oversize Material Wet Mass`,
      [`${prefix}.FieldResults.AssociatedCompactionData.ExternalTest.Results.MaximumDryDensity`]: `Maximum Dry Density`,
      [`${prefix}.FieldResults.AssociatedCompactionData.ExternalTest.Results.OptimumMoistureContent`]: `Optimum Moisture Content`,
      [`${prefix}.FieldResults.AssociatedCompactionData.ExternalTest.Results.OversizeSieveApertureSizeId`]: `Oversize Sieve Aperture Size`,
      [`${prefix}.FieldResults.AssociatedLabMoistureContent.ExternalTest.Results.MoistureContentPercent`]:
        'Moisture Content',
      [`${prefix}.FieldResults.AssociatedFieldWetDensity.ExternalTest.Results.FieldMoistureContent`]:
        'Moisture Content',
      [`${prefix}.FieldResults.AssociatedFieldWetDensity.ExternalTest.Results.FieldWetDensity`]: 'Wet Density',

      [`${prefix}.Results.MoistureVariation`]: 'Moisture Variation',
      [`${prefix}.Results.OptimumMoistureContent`]: 'Optimum Moisture Content',
      [`${prefix}.Results.MoistureRatio`]: 'Moisture Ratio',
      [`${prefix}.Results.TotalSampleDryMass`]: 'Total Sample Dry Mass',
      [`${prefix}.Results.OversizeWet`]: 'Wet oversize',
      [`${prefix}.Results.OversizeDry`]: 'Dry Oversize',
      [`${prefix}.Results.MaximumDryDensity`]: 'Maximum Dry Density',
      [`${prefix}.Results.AdjustedMaximumDryDensity`]: 'Adjusted Maximum Dry Density',
      [`${prefix}.Results.AdjustedOptimumMoistureContent`]: 'Adjusted Optimum Moisture Content',
      [`${prefix}.Results.DryDensityRatio`]: 'Dry Density Ratio',
      [`${prefix}.Results.DryDensity`]: 'Dry Density',
      [`${prefix}.Results.SoilMoistureLevel`]: 'Soil Moisture Compared to Optimum Moisture',
      [`${prefix}.Results.ResultMoistureContent`]: 'Field Moisture Content',
      [`${prefix}.Results.FieldWetDensity`]: `Field Wet Density`,
    }),
    convertLabelUomMapToConfig({
      [`${prefix}.OversizeCorrectionData.OversizeSieveApertureSize`]: 'mm',
      [`${prefix}.FieldResults.TimesBetweenAdditionOfStabiliserAndCompaction`]: 'h',
      [`${prefix}.FieldResults.TimeBetweenAdditionOfStabiliserAndCompaction`]: 'h',
      [`${prefix}.FieldResults.FieldMoistureContent`]: '%',
      [`${prefix}.FieldResults.OptimumMoistureContent`]: '%',
      [`${prefix}.FieldResults.AssociatedLabMoistureContent.ExternalTest.Results.MoistureContentPercent`]: '%',
      [`${prefix}.FieldResults.AssociatedCompactionData.ExternalTest.Results.OptimumMoistureContent`]: '%',
      [`${prefix}.FieldResults.AssociatedFieldWetDensity.ExternalTest.Results.FieldMoistureContent`]: '%',
      [`${prefix}.FieldResults.LabMoistureContent`]: '%',
      [`${prefix}.Results.MoistureVariation`]: '%',
      [`${prefix}.Results.OptimumMoistureContent`]: '%',
      [`${prefix}.Results.AdjustedOptimumMoistureContent`]: '%',
      [`${prefix}.Results.MoistureRatio`]: '%',
      [`${prefix}.Results.OversizeWet`]: '%',
      [`${prefix}.Results.OversizeDry`]: '%',
      [`${prefix}.Results.DryDensityRatio`]: '%',
      [`${prefix}.Results.ResultMoistureContent`]: '%',
    })
  );

export default getLabelConfig;
